<template>
	<q-carousel
		animated
		v-model="current_slide"
		arrows
		height="100%"
		control-color="primary"
		v-model:fullscreen="fullscreen"
		@before-transition="nextSlide"
	>
		<template v-for="slide in file_preview" :key="slide.seq">
			<q-carousel-slide :name="slide.seq">
				<div
					v-if="!loading"
					class="full-width full-height bg-white flex items-center justify-center scroll"
				>
					<div class="flex">
						<img class="full-width" :src="current_file" alt="" />
					</div>
				</div>
				<div v-else class="full-width full-height bg-white flex items-center justify-center">
					<q-spinner color="primary" size="3em" />
				</div>
			</q-carousel-slide>
		</template>
		<template v-slot:control>
			<q-carousel-control position="bottom-right" :offset="[18, 18]">
				<q-btn
					push
					round
					dense
					color="white"
					text-color="primary"
					:icon="fullscreen ? 'fal fa-compress' : 'fal fa-expand'"
					@click="fullscreen = !fullscreen"
				/>
			</q-carousel-control>
		</template>
	</q-carousel>
</template>

<script>
export default {
	props: ['file_preview'],

	data() {
		return {
			current_slide: 0,
			fullscreen: false,
			current_file: '',
			loading: false,
		}
	},
	methods: {
		nextSlide(newVal, oldVal) {
			this.current_slide = newVal
			this.fileUploaded(this.file_preview[newVal].file)
		},

		fileUploaded(url) {
			this.loading = true

			let data = {
				file_url: url,
			}

			this.$axios
				.post('/utils/presigned_url/', data)
				.then((response) => {
					this.current_file = response.data.file_url
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.image_picker = false
					this.loading = false
				})
		},
	},
	mounted() {
		this.fileUploaded(this.file_preview[0].file)
	},
}
</script>

<style lang="scss">
.fullscreen img {
	min-height: 100%;
}
</style>
